import React from 'react';
import ListingPreview from '../../../shared/templates/ListingTemplate/listing-preview';

export default function FoodPreview(props) {
  return (
    <ListingPreview {...props} section="food" />
  );
}